export default __webpack_public_path__ + "static/media/skins-desktop-grid_hebrew.a16d2f43.png";